import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: " How much does mobile app development cost in Washington DC?",
    answer: `<p>The average cost for mobile app development in Washington DC can range from $25,000 to $500,000 or more. However, you can use our app cost calculator to have a quick estimation for your app design & development.</p>`,
  },
  {
    question: "How much time do you take to deliver a mobile application?",
    answer: ` <p>A typical mobile app development project with average complexity usually spans over 4 to 6 months. However, the timeline can vary based on the project's complexity:</p>  
        <ul>
        <li>For a simple app development: Expect a duration of 2 to 4 months.</li>
        <li>In the case of a moderately complex app: The project may take around 4 to 6 months.</li>
        <li>Highly intricate app development: These projects can extend beyond 9 months to ensure all complexities are well-addressed.</li>
    </ul>`,
  },
  {
    question:
      "Do I have to sign a NDA before signing off the project documents?",
    answer: `<p>Yes, we require you to sign a Non-Disclosure Agreement (NDA) to ensure the confidentiality of your app idea, guaranteeing it won't be disclosed to any third party.</p>`,
  },
  {
    question: "How do I find developers to make an app?",
    answer: ` <p>You can find a professional app developers in Washington DC following the steps below:</p>  
        <ul>
        <li>Know your requirements: You should know which developer you’re looking for. (be specific with the platforms, technologies)</li>
        <li>Research and Shortlist: Begin your search by researching local app development companies and freelance developers in Washington DC. Explore their portfolios, read reviews, and check their expertise in the technologies you require.</li>
        <li>Check References: Request references from previous clients and contact them to gain insights into their experiences working with the developers.</li>
        <li>Assess Compatibility: Evaluate how well the developer understands your project's goals and aligns with your vision.</li>
        <li>Make a Decision: Based on your research and evaluations, select the professional app developer in Washington DC that best matches your project's requirements and your business goals.</li>
    </ul>`,
  },
  {
    question:
      "How can I locate skilled mobile app developers in Washington DC near me?",
    answer: `<p>You can get a ton of results by just searching for "app developers in Washington DC near me" on Google. Explore their portfolios and services by visiting their websites. After that, schedule a session with their specialists to learn more about their services for developing apps and go over the specifics of your project needs.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
